export default "__VITE_ASSET__9619989d__"